<template>
  <!-- 写一个组件 用来当做对话框 -->
  <el-dialog title="单位子账户" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
    <el-row class="Childsadd">
      <el-col :span="22" />
      <el-col :span="2">
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addChild">添加</el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column prop="#" type="index" width="50" />
      <el-table-column prop="USER_NAME" label="持有人" width="80">
        <template slot-scope="scope">
          <el-input v-if="scope.$index === index" v-model="scope.row.USER_NAME" placeholder="请输入用户" />
          <span>{{ scope.row.USER_NAME }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="USER_ID" label="账号" />
      <el-table-column prop="phone" label="手机号" />
      <!-- <el-table-column prop="USER_PASS" label="密码" /> -->
      <el-table-column label="状态">
        <template slot-scope="{ row }">
          <el-switch v-model="row.state" active-color="#13ce66" inactive-color="#ff4949" @change="switchChange(row)" />
          <span> {{ row.IS_ACTIVE == 1 ? "激活" : "禁用" }} </span>
        </template>
      </el-table-column>

      <el-table-column prop="CREATE_DATE" label="创建/更新时间" />
      <el-table-column prop="END_TIME" label="过期时间" />
      <el-table-column prop="address" label="操作" :width="230">
        <template slot-scope="{ $index, row }">
          <el-button v-if="row.IS_ACTIVE === '1'" size="small" type="primaty" @click="jurisdiction($index, row)">
            权限
          </el-button>
          <!-- <el-button size="small" type="primaty" @click="amend( $index, row)">
            {{ $index === index ?"确认" :'修改' }}
          </el-button> -->
          <el-tooltip class="item" effect="dark" content="这个操作将重置该账号的密码" placement="top">
            <el-button size="small" type="primaty" @click="reset($index, row)">
              重置
            </el-button>
          </el-tooltip>

          <el-button size="small" type="danger" @click="remove($index, row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog width="30%" :title="Title" :visible.sync="innerVisible" append-to-body>
      <add-child :child-user-account="childUserAccount" @ConfirmAdd="ConfirmAdd" />
    </el-dialog>
    <el-dialog width="60%" title="权限列表" :visible.sync="jurisdictionShow" append-to-body>
      <amend-child />
      <span slot="footer" class="dialog-footer">
        <el-button @click="jurisdictionShow = false">取 消</el-button>
        <el-button type="primary" @click="ConfirmAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="30%" :title="Title" :visible.sync="resetShow" append-to-body>
      <el-form ref="formReset" :model="formReset" label-width="80px">
        <el-form-item label="新的密码" prop="passWord" :rules="{ required: true, message: '请输入新密码', trigger: 'blur' }">
          <el-input v-model="formReset.passWord" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="resetClick('formReset')">确认新密码</el-button>
          <el-button>取消</el-button>
        </el-form-item>
      </el-form>
      <!-- <add-child @ConfirmAdd="ConfirmAdd" /> -->
    </el-dialog>
    <!-- </el-card> -->
  </el-dialog>
</template>

<script>
import { updatePhone, getPhone } from '@/api/user'
// import { number } from 'echarts/lib/export'
import addChild from './components/addChild.vue'
import AmendChild from './components/amendChild.vue'
// import { base64 } from 'jszip/lib/support';
const base64 = require('js-base64').Base64

export default {
  components: { addChild, AmendChild },
  // 通过传值的方式操作对话框的显示隐藏
  data() {
    return {
      childUserAccount: '',
      // state:false,
      operation: '修改',
      index: -1,
      type: '', // 当前状态的字符串 number 形式
      Title: '', // 切换是添加还是修改
      childUserId: '',
      dialogVisible: false,
      innerVisible: false,
      jurisdictionShow: false,
      resetShow: false, // 重置密码的对话框
      tableData: [], // 列表数据
      formReset: {
        // 重置密码
        passWord: ''
      }
    }
  },
  computed: {
    userId() {
      const a = this.$store.getters.token
      return JSON.parse(base64.decode(a.split('.')[1])).userId
    }
  },

  created() {
    // 创建
    this.$EventBus.$on('childs', () => {
      this.dialogVisible = true
    })

    this.findChildList()
  },
  beforeMount() { },
  mounted() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  methods: {
    reset(index, row) {
      // 重置密码
      this.childUserId = row.USER_ID

      this.$confirm('确定重置密码?该操作不会修改账号权限!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.resetShow = true
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    resetClick(formReset) {
      // 点击确认新密码
      this.$refs[formReset].validate(valid => {
        if (valid && this.childUserId) {
          this.defaultPassword()
        } else {
          this.$message.error('失败，请刷新重试')
        }
      })
    },

    async defaultPassword() {
      const response = await this.$axios.put(
        '/api/childuser/defaultPassword',
        this.qs.stringify({
          userId: this.childUserId,
          password: this.formReset.passWord
        }),
        {
          headers: { Authorization: this.$store.getters.token }
        }
      )
      if (response.data.code !== 200) { return this.$message.error(response.data.message) }
      this.$message.success('重置成功,新密码为' + this.formReset.passWord)
    },
    amend(index, row) {
      // 点击修改按钮
      if (this.operation === '确认') {
        this.operation = '修改'
        this.index = -1
        return false
      }
      this.operation = '确认'
      this.index = index

      // this.Title = '修改'
      // this.innerVisible = true
    },
    switchChange(row) {
      if (row.state) {
        this.type = '1'
      } else {
        this.type = '0'
      }
      // /childuser/activeChildUser
      if (this.type && row.USER_ID) {
        this.activeChildUser(row)
      } else {
        this.$message.error('失败，请刷新重试')
      }
    },
    remove(index, row) {
      this.childUserId = row.USER_ID
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delUser()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    jurisdiction() {
      this.$message('暂不能更改权限')
    },
    async activeChildUser(item) {
      const response = await this.$axios.put(
        '/api/childuser/activeChildUser',
        this.qs.stringify({
          userId: item.USER_ID,
          isActive: this.type,
          type: 'all',
          deviceIds: ''
        }),
        {
          headers: { Authorization: this.$store.getters.token }
        }
      )
      if (response.data.code !== 200) { return this.$message.error(response.data.message) }
      this.$message.success('状态更新成功')
      this.findChildList()
    },
    async delUser() {
      const response = await this.$axios.delete(
        '/api/childuser/delUser?' +
        this.qs.stringify({
          userId: this.childUserId
        }),
        {
          headers: { Authorization: this.$store.getters.token }
        }
      )
      if (response.data.code !== 200) { this.$message.error(response.data.message) }
      this.$message.success('删除成功')
      this.findChildList()
    },
    async ConfirmAdd(item) {
      item.parentUser = this.userId
      // 确认添加按钮
      const response = await this.$axios.post(
        '/api/childuser/addUser?' + this.qs.stringify(item),
        {},
        {
          headers: { Authorization: this.$store.getters.token }
        }
      )
      console.log(item, 'itemitem');

      if (response.data.code !== 200) { return this.$message.error(response.data.message) }
      const data = await updatePhone({ userId: item.userId, phone: item.phone })
      console.log(data, '更新手机号信息');
      if (data.code !== 200) { return this.$message.error(response.data.message) }
      this.$message.success('创建成功,密码为' + item.passWord)
      this.innerVisible = false
      this.findChildList()
    },
    padding2(num, length) {
      // 补零神器
      if ((num + '').length >= length) {
        return num
      }
      return this.padding2('0' + num, length)
    },
    addChild() {
      const tableData = JSON.parse(JSON.stringify(this.tableData))
      let newUserId = ''
      if (tableData.length === 0) {
        newUserId = this.userId + '-001'
        this.childUserAccount = newUserId
        this.Title = '添加'
        this.innerVisible = true
      } else {
        const oldData = tableData.pop() //
        let childOldUserId = oldData.USER_ID //
        childOldUserId = childOldUserId.substring(childOldUserId.length - 3) //
        const indexSort = Number(childOldUserId) + 1 // 转化成 数字
        const serial =
          indexSort >= 10 && indexSort + 1 < 100
            ? '0' + indexSort
            : indexSort < 10
              ? '00' + indexSort
              : indexSort
        this.childUserAccount = `${oldData.P_USER_ID}-${serial}`
        this.Title = '添加'
        this.innerVisible = true
      }
    },
    handleClose(done) {
      done()
    },
    // 获取数据
    // /childuser/findChildList
    // parentUserId 父账号id
    async findChildList() {
      const response = await this.$axios.get(
        '/api/childuser/findChildList?parentUserId=' + this.userId,
        {
          headers: { Authorization: this.$store.getters.token }
        }
      )

      const tableData = response.data.data

      tableData.filter(item => {
        if (item.IS_ACTIVE == 1) {
          // eslint-disable-line
          item.state = true
        } else {
          item.state = false
        }
      })
      this.tableData = tableData.sort((x, y) => {
        const xV = x.USER_ID.substring(x.USER_ID.length - 3) // 这报错 数组中没有user_id
        const yV = y.USER_ID.substring(y.USER_ID.length - 3)
        return Number(xV) - Number(yV)
      })
      // USER_ID
      // getPhone
      this.tableData.forEach(item => {
        // 只处理有 USER_ID 的项
        if (item.USER_ID) {
          // 调用你的 getPhone 接口
          getPhone({userId:item.USER_ID}).then((res) => {
          
            item.phone = res.data || '';
          }).catch(() => {
            // 失败时标记
            item.phone = '';
          });
        } else {
          item.phone = '';
        }
      });
      console.log(  this.tableData,'tableData');
      
    },
    getPhone(userId) {
      getPhone(userId).then((res) => {

      })
    }
  },
  beforeCreated() { }
}
</script>

<style>
.el-dialog__body {
  padding: 0 20px 20px 20px;
}

/* .box-card{
    margin-top: 20px;
} */
.Childsadd {
  margin-bottom: 20px;

  /* width: 100%; */
  /* background-color: aqua; */
}

.Childsadd input {
  width: 200px;
}
</style>
